import { useCallback } from "react"

import { Col, Row } from "react-bootstrap"

import ClinicGroupFF from "../../../../api/Clinics/Models/ClinicGroupFF"
import ToggleSwitch from "../../../FormattedInputs/ToggleSwitch"

interface IFFClinicGroupRowProps {
  group: ClinicGroupFF
  onClick: (group: ClinicGroupFF, excluded: boolean) => void
}

function FFClinicGroupRow(props: IFFClinicGroupRowProps) {
  const { group, onClick } = props

  const handleExcludeGroup = useCallback(
    (checked: boolean) => {
      onClick(group, checked)
    },
    [group, onClick]
  )

  return (
    <Row>
      <Col sm={9} className="d-flex align-items-center">
        {group.Name}
      </Col>
      <Col sm={3} className="d-flex align-items-center">
        <ToggleSwitch
          className="my-1 mx-auto"
          on="Yes"
          off="No"
          checked={group.excluded}
          onCheck={handleExcludeGroup}
        />
      </Col>
    </Row>
  )
}

export default FFClinicGroupRow
